import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminPillSelectStyles,
} from "../../../../components/Models/admin-modal-theme";
import { Box, FormLabel, Heading, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { approveStudentRequest } from "../../../../modules/admin-modules/students/Actions";

const ApproveStudentModal = ({ studentData, isOpen, onClose, groupsOptions }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.students.isSuspend);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupError, setGroupError] = useState("");

  useEffect(() => {
    if (studentData?.group?.id) {
      setSelectedGroup({
        value: studentData.group.id,
        label: studentData.group.name,
      });
    } else {
      setSelectedGroup(null);
    }
  }, [studentData]);

  const handleClose = () => {
    setSelectedGroup(null);
    setGroupError("");
    onClose();
  };

  const handleApprove = () => {
    if (!selectedGroup?.value) {
      setGroupError("Please select a group");
      return;
    }

    dispatch(
      approveStudentRequest({
        id: studentData?.id,
        studentGroupId: selectedGroup.value,
      })
    );
    handleClose();
  };

  const header = (
    <Box>
      <Heading
        textAlign="center"
        fontSize="28px"
        fontWeight="800"
        color="var(--text-primary)"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        Approve student
      </Heading>
    </Box>
  );

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={handleClose}
      openVar={isOpen}
      buttonTitle="Approve student"
      buttonFunc={handleApprove}
      size="2xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
    >
      <VStack spacing={5} align="stretch">
        <Text fontWeight="700" color="var(--text-primary)">
          Student: {studentData?.name}
        </Text>

        <Box>
          <FormLabel fontWeight="700" color="var(--text-primary)" mb={2}>
            Select group
          </FormLabel>
          <Select
            options={groupsOptions}
            value={selectedGroup}
            onChange={(option) => {
              setSelectedGroup(option);
              setGroupError("");
            }}
            styles={adminPillSelectStyles({ menuZIndex: 20 })}
            placeholder="Choose a group"
            isClearable
          />
          {groupError ? (
            <Text color="red.500" fontSize="sm" mt={2}>
              {groupError}
            </Text>
          ) : null}
        </Box>
      </VStack>
    </MainModel>
  );
};

export default ApproveStudentModal;
